<template>
    <img :src="url" style="height: 30px; width: 30px;"></img>
</template>

<script>
export default {
    props: {
        country: {
            type: String,
            required: true,
        }
    },

    computed: {
        url() {
            return "https://flagpedia.net/data/flags/h80/" + this.country.toLowerCase() + ".webp"
        }
    }
}
</script>